import React, { useEffect, useState } from "react";
import {
  Button,
  Heading,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View,
  Icon,
  Alert,
  Link,
  Breadcrumbs,
  Tabs
} from "@aws-amplify/ui-react";
import "./Users.css";
import { MdArrowBack, MdBlock, MdChevronRight, MdEdit, MdLock, MdLockOpen, MdRefresh } from "react-icons/md";
import CreateUserForm from "./CreateUserForm";
import ModifyUserForm from "./ModifyUserForm";
import { blockUserAPI, getUsersListAPI, unblockUserAPI } from "../../data/api";
import { getUserRoleLabel } from "../../data/interfaces";
import { NavLink, useLocation } from "react-router-dom";
import RisorseTaskList from "./RisorseTaskList";

export interface User {
  sub: string;
  username: string;
  name?: string;
  email?: string;
  role?: string;
  enabled?: boolean;
}

export interface UsersTableProps {
  users?: User[];
}

const UserDetail = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get('user');

  // State to manage reload key for tabs
  const [reloadKey, setReloadKey] = useState(0);

  // Function to force reload
  const forceReload = () => {
    setReloadKey((prevKey) => prevKey + 1);

  };
  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
          <NavLink to='/users' className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <h2>Risorse associate a <i>{username}</i></h2>
          <h2 style={{cursor: 'pointer'}}><Icon marginLeft="5px" as={MdRefresh} onClick={forceReload}/></h2>
        </div>
        <Tabs.Container isLazy={true} defaultValue="1">
          <Tabs.List>
            <Tabs.Item value="1">Task</Tabs.Item>
            <Tabs.Item value="2" disabled>Assistenze</Tabs.Item>
          </Tabs.List>
        <Tabs.Panel value="1">
          <RisorseTaskList key={`risorsetask-${reloadKey}`} username={username} onUpdate={forceReload}></RisorseTaskList>
        </Tabs.Panel>
        <Tabs.Panel value="2" isDisabled>
        </Tabs.Panel>
        </Tabs.Container>
      </View>
    </View>
  );
};

export default UserDetail;
